@if (hasItems()) {
  <ul class="upload-status-list" role="list">
    @for (item of items(); track item.id) {
      <li class="upload-status-list__item">
        <div class="upload-status-list__info">
          <ocp-upload-status-badge [status]="item.status" [percentage]="item.percentage" />
          <span class="upload-status-list__name">{{ item.name }}</span>
          @if (item.status === 'Uploaded' && item.creationDate) {
            <span class="upload-status-list__date">{{ item.creationDate | date: 'short' }}</span>
          }
        </div>
        <div class="upload-status-list__actions">
          @if (isCancellable(item)) {
            <button
              hlmBtn
              variant="ghost"
              size="sm"
              class="upload-status-list__action-btn"
              (click)="onCancel(item)"
              [attr.aria-label]="('models.embedded.cancel-upload' | translate) + ' ' + item.name"
            >
              <ocp-themed-icon name="cross.svg" />
              {{ 'models.embedded.cancel-upload' | translate }}
            </button>
          }
        </div>
        @if (item.status === 'Uploaded') {
          <div class="upload-status-list__uploaded-actions">
            <button
              hlmBtn
              size="sm"
              (click)="onViewModel(item)"
              [attr.aria-label]="('models.embedded.view-model' | translate) + ' ' + item.name"
            >
              <ocp-themed-icon name="open-in-new.svg" mode="swap" />
              {{ 'models.embedded.view-model' | translate }}
            </button>
            <button
              hlmBtn
              variant="ghost"
              size="sm"
              class="upload-status-list__action-btn"
              (click)="onCopyLink(item)"
              [attr.aria-label]="('models.embedded.copy-link' | translate) + ' ' + item.name"
            >
              <ocp-themed-icon name="hyperlink.svg" />
              {{ 'models.embedded.copy-link' | translate }}
            </button>
          </div>
        }
      </li>
    }
  </ul>
} @else {
  <p class="upload-status-list__empty">
    {{ 'models.embedded.no-current-uploads' | translate }}
  </p>
}
